import { render } from "./BirdSoundTutorial.vue?vue&type=template&id=35be3e5e"
import script from "./BirdSoundTutorial.vue?vue&type=script&lang=js"
export * from "./BirdSoundTutorial.vue?vue&type=script&lang=js"

import "./BirdSoundTutorial.vue?vue&type=style&index=0&id=35be3e5e&lang=css"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__